module.exports = __webpack_public_path__ + "static/img/teach2.28311ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/teach2.png
// module id = VW/p
// module chunks = 1